import * as React from 'react';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import {
    impersonateErrorMessage,
    useImpersonate,
} from '../hooks/useImpersonate';

export interface ImpersonateDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export function ImpersonateDialog({ open, onOpenChange }: ImpersonateDialogProps) {
    const [email, setEmail] = React.useState('');
    const [error, setError] = React.useState<string | null>(null);
    const impersonate = useImpersonate();

    const [wasOpen, setWasOpen] = React.useState(open);
    if (wasOpen !== open) {
        setWasOpen(open);
        if (!open) {
            setEmail('');
            setError(null);
        }
    }

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        const target = email.trim();
        if (!target) {
            setError('Введите email');
            return;
        }
        setError(null);
        impersonate.mutate(target, {
            onError: (err) => setError(impersonateErrorMessage(err)),
        });
    };

    const submitting = impersonate.isPending;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <form onSubmit={handleSubmit}>
                    <DialogHeader>
                        <DialogTitle>Открыть другой аккаунт</DialogTitle>
                        <DialogDescription>
                            Введите email пользователя. Сессия будет заменена; чтобы вернуться,
                            нужно выйти и войти снова.
                        </DialogDescription>
                    </DialogHeader>
                    <div className="mt-4 space-y-2">
                        <Input
                            type="email"
                            autoFocus
                            placeholder="user@mrdoors.ru"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={submitting}
                            aria-label="Email аккаунта"
                        />
                        {error && (
                            <p className="text-body2 text-destructive" role="alert">
                                {error}
                            </p>
                        )}
                    </div>
                    <DialogFooter className="mt-6">
                        <Button
                            type="button"
                            variant="ghost"
                            onClick={() => onOpenChange(false)}
                            disabled={submitting}
                        >
                            Отмена
                        </Button>
                        <Button type="submit" disabled={submitting}>
                            Открыть
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
